import React, {useEffect, useState} from 'react';
import Table from "../../../system/components/table";
import {normalizeGraph} from "./strategy-map";
import {useGoal} from "../../../models/goal/use-goal";
import {useProject} from "../../../models/project/use-project";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {useTranslate} from "../../../system/useTranslate";
import {IconField} from "primereact/iconfield";
import {InputIcon} from "primereact/inputicon";
import {InputText} from "primereact/inputtext";
import {Divider} from "primereact/divider";
import {Dropdown} from "primereact/dropdown";
import {usePublishAiScope} from "../../../system/ai-scope-context";

function MyGoals(props) {
    const goal = useGoal();
    const {config, workspaceMembershipData} = useSelector((state) => state.app);
    const [goals, setGoals] = useState([]);
    const navigate = useNavigate();
    const [filteredGoals, setFilteredGoals] = useState([]);
    usePublishAiScope({
        activeTab: "my-goals",
        selectedEntityIds: filteredGoals.map((item) => item.documentId || item.id),
        filters: {scopeSelectionProvided: true},
    });
    useEffect(() => {
        getGoals();
        // Query scope changes with the active workspace membership.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        workspaceMembershipData?.workspace?.id,
        workspaceMembershipData?.documentId,
    ]);

    const getGoals = ()=>{
        (async () => {
            const [_goalsData] = await Promise.all([
                goal.getGoals(workspaceMembershipData?.workspace?.id),
            ]);
            setGoals(_goalsData);
            setFilteredGoals(_goalsData)
        })();
    }

    return (
        <div className="p-2 ">
            <GoalFilter goals={goals} onChange={setFilteredGoals} />
            <div className="border-1 border-100 border-round-3xl shadow-1 pt-4 pb-3 surface-50">
                <Table onRowClick={(item)=>{navigate(`/goals/${item.value.id}`)}} fields={goal.prepareTable({config, actions:{}}).fields} fieldsConfig={goal.prepareTable({config, actions:{}}).fieldsConfig} showHeader={false} value={filteredGoals} style={null}/>
            </div>
        </div>
    );
}

function GoalFilter({onChange, goals}) {
    const translate = useTranslate();

    const [filters, setFilters] = useState({
        search: "",
        // assignee: null,
        // members: null,
        // portfolio: null,
        // active: true,
    })

    // const assigneeOption = [
    //     {
    //         id: null,
    //         fullname: translate("all")
    //     },
    //     ...new Map((goals ?? [])
    //         .filter(t => t.assignee).map(t => [
    //             t.assignee.id, t.assignee])).values()]


    // const memberOptions = [
    //     {
    //         id: null,
    //         fullname: translate("all")
    //     },
    //     ...new Map(
    //         (goals ?? [])
    //             .flatMap(t => t.members ?? [])
    //             .map(m => [m.id, m])
    //     ).values()
    // ]

    // const portfolioOptions = [
    //     {
    //         id: null,
    //         title: translate("all")
    //     },
    //     ...new Map(
    //         (goals ?? [])
    //             .flatMap(t => t.projects ?? [])
    //             .map(p => [p.id, p])
    //     ).values()
    // ]

    // const portfolioOptions = [
    //     ...new Map(
    //         (goals ?? [])
    //             .flatMap(t => t.portfolio ?? [])
    //             .map(p => [p.id, p])
    //     ).values()
    // ]

    useEffect(() => {
        let result = [...(goals ?? [])]

        if (filters.search?.trim()) {
            const value = filters.search.toLowerCase()
            result = result.filter(g =>
                g.title?.toLowerCase()?.includes(value)
            )
        }
        // if (filters.assignee) {
        //     result = result.filter(
        //         task => task.assignee?.id === filters.assignee.id)
        // }
        // if (filters.members) {
        //     result = result.filter(task =>
        //         task.members?.some(
        //             member => member?.id === filters.members.id)
        //     )
        // }
        // if(filters.portfolio){
        //     result = result.filter(t =>
        //         t.projects?.some(p=> p.id === filters.portfolio.id))
        // }
        // if (filters.active) {
        //     result = result.filter(
        //         task => task.status === "active")
        // }

        onChange(result)
    }, [filters, goals]);


    return (
        <div className="flex flex-wrap gap-2 align-items-center p-1 ">
            <div className="flex-1 max-w-30rem pb-2">
                <IconField>
                    <InputIcon className="pi pi-search"/>
                    <InputText className="w-full pl-8 p-inputtext-xs surface-100"
                               value={filters.search}
                               placeholder={translate("quick-search")}
                               onChange={(e) => setFilters(prev => ({
                                   ...prev, search: e.target.value
                               }))}

                    />
                </IconField>
            </div>

        {/*    <Divider layout="vertical" className="hidden md:block h-2rem m-0"/>*/}

        {/*    <div className="flex flex-wrap gap-2 align-items-center lg:justify-content-end">*/}

        {/*        /!*assignee*!/*/}
        {/*        <Dropdown className="p-inputtext-xs surface-100 w-8rem"*/}
        {/*                  value={filters.assignee}*/}
        {/*                  options={assigneeOption}*/}
        {/*                  optionLabel="fullname" placeholder={translate(("assignee"))}*/}
        {/*                  onChange={(e) => setFilters(prev => ({*/}
        {/*                      assignee: e.value?.id ? e.value : null                          }))}*/}

        {/*        />*/}

        {/*        /!*member*!/*/}
        {/*        <Dropdown*/}
        {/*            className="p-inputtext-xs surface-100 w-8rem"*/}
        {/*            value={filters.members}*/}
        {/*            options={memberOptions}*/}
        {/*            optionLabel="fullname"*/}
        {/*            placeholder={translate(("members"))}*/}
        {/*            onChange={(e) => setFilters(prev => ({*/}
        {/*                members: e.value?.id ? e.value : null*/}
        {/*            }))}*/}

        {/*        />*/}

        {/*        /!*portfolio *!/*/}
        {/*        <Dropdown*/}
        {/*            className="p-inputtext-xs surface-100 w-8rem"*/}
        {/*            value={filters.portfolio}*/}
        {/*            options={portfolioOptions}*/}
        {/*            placeholder={translate(("portfolio"))}*/}
        {/*            optionLabel="title"*/}
        {/*            onChange={(e) => setFilters(prev => ({*/}
        {/*                ...prev,*/}
        {/*                portfolio: e.value?.id ? e.value : null*/}
        {/*            }))}*/}
        {/*        />*/}
        {/*        /!*{filters.active && (*!/*/}
        {/*        /!*    <Button*!/*/}
        {/*        /!*        outlined*!/*/}
        {/*        /!*        label={translate("active")}*!/*/}
        {/*        /!*        iconPos="left"*!/*/}
        {/*        /!*        icon="mi mi:close"*!/*/}
        {/*        /!*        className="border-round-xl"*!/*/}
        {/*        /!*        onClick={() => setFilters(prev => ({...prev, active:false}))}*!/*/}

        {/*        /!*    />*!/*/}
        {/*        /!*)}*!/*/}


        {/*    </div>*/}
        </div>
    )
}

export default MyGoals;
